export default __webpack_public_path__ + "static/media/diwali.50b39f9c.jpg";